import store from "../../store";

export const checkCOCValidationRequired = (billingCountry, context, level, cocRegions) => {
  const geoPolData = store.getState().common.geoPolData;
  if (cocRegions.toLowerCase() === 'all' && !(context === "Renewal" && level === "Registered")) {
    return true;
  }
  let isCOCRegion = false;
  const cocRegionsList = cocRegions.split(",");
  for (let i = 0; i < cocRegionsList.length; i = i + 1){
    const countryList = Object.keys(geoPolData[cocRegionsList[i]]?.countries || {});
    if (countryList.includes(billingCountry)) {
      isCOCRegion = true;
      break;
    }
  }
  if (isCOCRegion && !(context === "Renewal" && level === "Registered"))
    return true;
  return false;
}

export const getContacts = (contacts, cocStatus = {}) => {
  let retObj = {};
  let contact_suffix = [];
  let rearrangedContacts = [];
  let primaryObj = {};
  let secondaryObj = {};
  contacts.map((obj) => {
    if ((obj["email"] != null || obj["email"] != undefined) && cocStatus !== undefined &&
      obj["email"] in cocStatus) {
      obj.cocStatus = cocStatus[obj["email"]];
    }
    if (obj.mainContactType == "Primary") {
      primaryObj = obj;
    }
    else if (obj.mainContactType == "Secondary") {
      secondaryObj = obj;
    }
    else {
      rearrangedContacts.push(obj);
    }
    return null;
  });
  if (secondaryObj !== {}) {
    rearrangedContacts.unshift(secondaryObj);
  }
  if (primaryObj !== {}) {
    rearrangedContacts.unshift(primaryObj);
  }
  rearrangedContacts.map((obj, index) => {
    Object.keys(obj).map(ele => {
      retObj[ele === "recId" ? "contactId_" + index : ele + "_" + index] = ["additionalContactType", "certification"].includes(ele) ? obj[ele].split(";") : obj[ele];
      return null;
    });
    contact_suffix.push(index);
    return null;
  });
  return { retObj: retObj, contact_suffix: contact_suffix };
}